<template lang="">
  <modal-padrao
    ref="modal-movimentacao"
    max-width="70%"
    :titulo="tituloModal"
    :titulo-cancelar="$t('geral.botoes.cancelar')"
    :titulo-ok="$t('geral.botoes.confirmar')"
    :mostra-botao-salvar="false"
    :mostrar-botao-cancelar="indiceAba == 0"
    @cancelar="eventoBotaoVoltar"
  >
    <v-tabs
      v-model="indiceAba"
      class="abas-padrao"
      background-color="primary"
      color="primary"
      v-if="false"
    >
      <v-tab>
        {{ abaHistorico }}
      </v-tab>
      <v-tab :disabled="disabledAbaDetalhe">
        {{ abaDetalhe }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="indiceAba">
      <v-tab-item>
        <div
          class="mr-1 mt-2 d-flex justify-between"
          style="display: flex; justify-content: space-between"
        >
          <v-chip v-if="instrumento?.codigoTag" small>
            {{ $t('modulos.instrumento.titulos.instrumento') }}:
            {{ instrumento?.codigoTag }}
          </v-chip>
          <botao-padrao
            @click="abrirFormMovimentacoes"
            :disabled="!instrumento?.setor"
            :tooltip="tooltipInstrumentoSemSetor(instrumento)"
          >
            {{ botaoAdd }}
          </botao-padrao>
        </div>
        <tabela-padrao-prime-vue
          class="mt-2"
          :colunas="colunas"
          :dados="tabela.dados"
          :mostrar-seletor="false"
          :por-pagina="tabela.porPagina"
          :quantidade-itens="tabela.quantidadeItens"
          :quantidade-paginas="tabela.quantidadePaginas"
          @paginar="listarMovimentacao"
        >
          <template #acoes="{ slotProps }">
            <div class="d-flex">
              <dropdown-padrao text color="secondary" style="width: 60px">
                <template #botao>
                  <v-icon> $dotsVertical </v-icon>
                </template>
                <dropdown-padrao-item
                  v-if="tipoMovimento !== 'Definitivo'"
                  @click="devolverInstrumento(slotProps.data)"
                  :disabled="slotProps.data.dataDevolucao"
                >
                  {{ $t('geral.botoes.devolver') }}
                </dropdown-padrao-item>
                <dropdown-padrao-item @click="abrirEditar(slotProps.data)">
                  {{ $t('geral.botoes.visualizar') }}
                </dropdown-padrao-item>
              </dropdown-padrao>
              <div
                v-if="
                  tipoMovimento !== 'Definitivo' &&
                  !slotProps.data.dataDevolucao
                "
                class="d-flex"
              >
                <icone-padrao
                  :icone="$vuetify.icons.values.loading"
                  :tooltip="'Instrumento Emprestado'"
                  :cor="'red'"
                />
              </div>
              <div v-else class="d-flex">
                <icone-padrao
                  :icone="$vuetify.icons.values.complete"
                  :tooltip="'Instrumento Devolvido'"
                  :cor="'green'"
                />
              </div>
            </div>
          </template>
        </tabela-padrao-prime-vue>
      </v-tab-item>
      <v-tab-item>
        <movimentacao-form-modal
          ref="formModalMovimentacao"
          :dados-instrumento="instrumento"
          :tipo-movimento="tipoMovimento"
          @reload-lista-movimento="listarMovimentacao"
          @cancelar-form="cancelarForm"
        />
      </v-tab-item>
    </v-tabs-items>
  </modal-padrao>
</template>
<script>
import MovimentacaoOutroSetorService from '@common/services/cadastros/MovimentacaoOutroSetorService';
import helpers from '@/common/utils/helpers';
import MovimentacaoFormModal from './MovimentacaoFormModal.vue';
import _ from 'lodash';
export default {
  components: { MovimentacaoFormModal },
  data() {
    return {
      setorAtual: null,
      tipoMovimento: null,
      mostrarBotaoCancelar: false,
      indiceAba: 0,
      instrumento: null,
      tabela: {
        dados: [],
        quantidadeItens: 0,
        quantidadePaginas: 0,
        paginaAtual: 1,
        porPagina: 10,
        setorAtual: null,
      },
      disabledAbaDetalhe: true,
      abaHistorico: null,
      abaDetalhe: null,
      botaoAdd: null,
    };
  },
  computed: {
    tituloModal: function () {
      if (this.tipoMovimento === 'Definitivo')
        return this.$t(
          'modulos.instrumento.modal_movimentacao.titulo_movimentacao'
        );
      return this.$t(
        'modulos.instrumento.modal_movimentacao.titulo_emprestimo'
      );
    },
    disabledAddoMovimento: function () {
      return (
        this.tipoMovimento === 'Emprestimo' && this.form.dataDevolucao === null
      );
    },
    colunas() {
      const headers = [
        {
          value: 'setorOrigem.nome',
          text: this.$t(
            'modulos.instrumento.modal_movimentacao.tabela.setor_origem'
          ),
          sortable: false,
        },
        {
          value: 'setorDestino.nome',
          text: this.$t(
            'modulos.instrumento.modal_movimentacao.tabela.setor_destino'
          ),
          sortable: false,
        },
        {
          value: 'dataMovimento',
          text: this.$t(
            'modulos.instrumento.modal_movimentacao.tabela.data_movimentacao'
          ),
          sortable: false,
          formatter: (v) => {
            if (v) return helpers.formatarDataBr(v, false);
          },
        },
        {
          value: 'dataPrevisaoDevolucao',
          text: this.$t(
            'modulos.instrumento.modal_movimentacao.tabela.data_previsao'
          ),
          sortable: false,
          formatter: (v) => {
            if (v) return helpers.formatarDataBr(v, false);
          },
        },
        {
          value: 'dataDevolucao',
          text: this.$t(
            'modulos.instrumento.modal_movimentacao.tabela.data_retorno'
          ),
          sortable: false,
          formatter: (v) => {
            if (v) return helpers.formatarDataBr(v, false);
          },
        },
      ];
      return headers;
    },
  },
  watch: {
    'form.setorDestinoInstrumentoId': {
      handler() {
        this.disabledSetorDestino = this.form.id && this.disabledSetorDestino;
      },
    },
  },
  methods: {
    eventoBotaoVoltar() {
      if (this.indiceAba) this.indiceAba = 0;
      else this.$refs['modal-movimentacao'].fecharModal();
    },
    devolverInstrumento: function (item) {
      this.indiceAba = 1;
      this.$nextTick()
        .then(() => {
          return this.$nextTick();
        })
        .then(() =>
          this.$refs.formModalMovimentacao.retornarFormDevolucao(item)
        );
    },
    abrirEditar: function (item) {
      this.form = _.cloneDeep(item);
      this.indiceAba = 1;
      this.$nextTick()
        .then(() => {
          return this.$nextTick();
        })
        .then(() => this.$refs.formModalMovimentacao.retornarForm(item));
    },
    abrirModal: function (instrumento, tipoMovimento) {
      this.indiceAba = 0;
      this.instrumento = _.cloneDeep(instrumento);
      this.tipoMovimento = tipoMovimento;
      this.definindoTextoPorTipoMovimento(this.tipoMovimento);
      this.listarMovimentacao();
      this.$refs['modal-movimentacao'].abrirModal();
    },
    tooltipInstrumentoSemSetor: function (item) {
      if (!item?.setor)
        return this.$t('modulos.instrumento.instrumento_sem_setor');
      return '';
    },
    listarMovimentacao: function (
      paginaAtual = this.tabela.paginaAtual,
      porPagina = this.tabela.porPagina
    ) {
      let parametros = {
        Page: paginaAtual,
        AmountPerPage: porPagina,
        instrumentoId: this.instrumento.id,
        tipoMovimento: this.tipoMovimento,
      };
      this.tabela.porPagina = porPagina;
      MovimentacaoOutroSetorService.listar(parametros).then((res) => {
        this.tabela.dados = res.data.items;
        this.setorAtual = this.tabela.dados[0]?.setorAtual;
        this.tabela.quantidadeItens = res.data.totalItems;
        this.tabela.quantidadePaginas = res.data.totalPages;
        this.tabela.paginaAtual = paginaAtual;
        this.tabela.porPagina = porPagina;
        this.tabela.selecionados = [];
      });
    },
    abrirFormMovimentacoes: function () {
      this.indiceAba = 1;
      this.instrumento = {
        ...this.instrumento,
        setorAtual: this.setorAtual,
      };
      this.$nextTick()
        .then(() => {
          return this.$nextTick();
        })
        .then(() => this.$refs.formModalMovimentacao.iniciarForm());
    },
    salvar: function () {
      if (!this.form.dataDevolucao) return this.salvarMovimentacao();

      return this.salvarDevolucao();
    },

    cancelarForm: function () {
      this.indiceAba = 0;
      return this.listarMovimentacao();
    },
    definindoTextoPorTipoMovimento: function (tipoMovimento) {
      if (tipoMovimento === 'Emprestimo') {
        this.abaHistorico = this.$t(
          'modulos.instrumento.modal_movimentacao.aba_historico_emprestimo'
        );
        this.abaDetalhe = this.$t(
          'modulos.instrumento.modal_movimentacao.aba_detalhe_emprestimo'
        );
        this.botaoAdd = this.$t(
          'modulos.instrumento.modal_movimentacao.add_emprestimo'
        );
      } else {
        this.abaHistorico = this.$t(
          'modulos.instrumento.modal_movimentacao.aba_historico_movimentacao'
        );
        this.abaDetalhe = this.$t(
          'modulos.instrumento.modal_movimentacao.aba_detalhe_movimentacao'
        );
        this.botaoAdd = this.$t(
          'modulos.instrumento.modal_movimentacao.add_movimentacao'
        );
      }
    },
    formatarDataDevolucao: function (dataDevolucao) {
      return helpers.formatarDataBr(dataDevolucao, false);
    },
  },
};
</script>
